import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';

export default function TableMenuOptions({
    menuItems
}: TableMenuOptionsProps) {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    //Funções manipuladoras
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        if (menuItems.length === 0) return
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        setAnchorEl(null);
    };

    const handleCloseAfterEvent = () => {
        setAnchorEl(null);
    };
    //

    return (
        <Box>
            <IconButton
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            >
                {
                    menuItems.map((item, index) => (
                        <MenuItem
                            key={index}
                            disabled={item.disabled}
                            onClick={(e) => {
                                item.action()
                                handleCloseAfterEvent()
                            }}
                            sx={{
                                display: "flex",
                                gap: 1.5
                            }}
                        >
                            {item.icon}
                            {item.label}
                        </MenuItem>
                    ))
                }
            </Menu>
        </Box>
    );
}

interface TableMenuOptionsProps {
    menuItems: Array<{
        label: string,
        action: () => void,
        icon: React.ReactElement,
        disabled?: boolean
    }>
}